<template>
  <div class="card-body pt-0">
    <div class="bg-white pt-3 d-flex">
      <div class="w-100" :class="editor != 'cat-' + category.id && 'd-flex align-items-center gap-1'">
        <div v-if="editor == 'cat-' + category.id">
          <div class="form-floating mb-3">
            <label style="opacity: 0.65; transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem)">Getränk</label>
            <multiselect
              :model-value="getComboValue('product', category.attributes.data)"
              :options="comboProducts"
              :searchable="false"
              track-by="key"
              :close-on-select="true"
              :show-labels="false"
              placeholder="Wählen Sie ein Getränk für ihr Kombo-Angebot aus"
              @select="updateCombo(category.id, 'product', $event)"
            >
              <template #singleLabel="props">
                <img :src="props.option.img" />
                <span class="option__title">{{ props.option.value }}</span>
              </template>
              <template #option="props">
                <img :src="props.option.img" />
                {{ props.option.value }}
              </template>
            </multiselect>
          </div>

          <div class="form-floating mb-3">
            <label style="opacity: 0.65; transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem)">Dazu</label>
            <multiselect
              :model-value="getComboValue('other', category.attributes.data)"
              :options="comboOther"
              :searchable="false"
              track-by="key"
              label="value"
              :close-on-select="true"
              :show-labels="true"
              placeholder="Wählen Sie aus, was Sie in Kombination anbieten möchten"
              @select="updateCombo(category.id, 'other', $event)"
            >
              <template #singleLabel="props">
                <img :src="props.option.img" />
                <span class="option__title">{{ props.option.value }}</span>
              </template>
              <template #option="props">
                <img :src="props.option.img" />
                {{ props.option.value }}
              </template>
            </multiselect>
          </div>
          <div class="row g-3" style="margin-bottom: -1rem">
            <div class="col-9 pb-3 d-flex align-items-center justify-content-end">
              <base-textarea
                :name="editor + '-combotext'"
                class="w-100"
                label="Angebotstext"
                :value="category.attributes.data?.text"
                :errors="category.errors?.data ? category.errors.data.text : null"
                @update:data="
                  updateCombo(category.id, 'text', {
                    key: $event.target.value,
                  })
                "
              ></base-textarea>
            </div>
            <div class="col-3">
              <base-form-input
                :name="editor + '-comboprice'"
                label="Angebotspreis"
                type="number"
                step=".01"
                :value="category.attributes.data?.price"
                :errors="category.errors?.data ? category.errors.data.price : null"
                @update:data="
                  updateCombo(category.id, 'price', {
                    key: $event.target.value,
                  })
                "
              ></base-form-input>
            </div>
          </div>
        </div>
        <template v-else>
          <h5 class="text-secondary fw-bold mb-0 handle" :class="{ disabled: multicheck }">
            <svg
              height="1em"
              viewBox="0 0 1792 1792"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="cursor-move"
              style="margin-top: -0.25rem"
            >
              <path
                d="M1408 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45zm0-384q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"
              ></path>
            </svg>
            <span class="ms-2" style="color: #a05a60">
              <i class="bi bi-gift-fill"></i>
            </span>
            Kombo-Angebot
          </h5>
          {{
            category.attributes?.data?.product && category.attributes?.data?.other
              ? '(' +
                getComboValue('product', category.attributes?.data)[0].value +
                ' + ' +
                getComboValue('other', category.attributes?.data)[0].value +
                (category.attributes?.data?.price
                  ? ': ' +
                    new Intl.NumberFormat('de-DE', {
                      style: 'currency',
                      currency: 'EUR',
                    }).format(category.attributes?.data?.price)
                  : '') +
                ')'
              : ''
          }}
        </template>
      </div>
      <div>
        <div
          v-if="multicheck"
          class="checkbox ms-3"
          :class="{
            'mb-3': category.relationships.menuItems.data.length > 0,
          }"
        >
          <label class="d-flex gap-2 align-items-center mb-1">
            <input v-model="mltchckd" :value="'cat-' + category.id" type="checkbox" class="form-check-input" />
            <div class="check fs-4"></div>
          </label>
        </div>
        <button
          v-else-if="editor != 'cat-' + category.id"
          type="button"
          class="btn border text-muted hover:text-secondary"
          @click="changeEditor('cat-' + category.id)"
        >
          <i class="bi bi-pencil-fill"></i>
        </button>
        <div v-else class="btn-group-vertical ms-3" role="group">
          <button
            type="button"
            class="btn border text-muted hover:text-secondary"
            @click="changeEditor('cat-' + category.id)"
          >
            <base-icon-save></base-icon-save>
          </button>
          <button type="button" class="btn border text-muted hover:text-primary" @click="deleteCategory(category.id)">
            <i class="bi bi-trash-fill"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

import Multiselect from 'vue-multiselect';

import { useVModel } from '@vueuse/core';

import isNil from 'lodash/isNil';

export default {
  components: {
    Multiselect,
  },
  props: {
    category: {
      type: Object,
      default: null,
    },
    editor: {
      type: String,
      default: '',
    },
    changeEditor: {
      type: Function,
      default: null,
    },
    deleteCategory: {
      type: Function,
      default: null,
    },
    multicheck: {
      type: Boolean,
      default: false,
    },
    multichecked: {
      type: Array,
      default: null,
    },
    combos: {
      type: Object,
      default: null,
    },
  },
  emits: ['update:data', 'update:multichecked'],
  setup(props, { emit }) {
    const mltchckd = useVModel(props, 'multichecked', emit);
    const comboProducts = ref(props.combos.product);
    const productCategory = ref(
      comboProducts.value.filter((product) => {
        return product.key === (props.category.attributes.data?.product ?? product.key);
      })[0].category
    );
    const comboOther = ref(props.combos.other.filter((item) => productCategory.value === item.category));

    const getComboLabel = (data) => {
      // label text von other beziehen
      let item = comboOther.value.filter((item) => item.key === data.other);
      if (!item || !item.length) {
        item = comboOther.value;
      }
      let labelText = (item ?? comboOther.value)[0].label.text;
      let productName = getComboValue('product', data)[0].value;
      let otherName = getComboValue('other', data)[0].value;

      return labelText.replace('%product%', productName).replace('%other%', otherName);
    };

    const getComboValue = (type, data) => {
      const comboData = type == 'product' ? comboProducts.value : comboOther.value;
      if (data && data[type]) {
        let value = comboData.filter((obj) => obj.key == data[type]);
        if (!value.length) {
          return [comboData[0]];
        }
        return value;
      }
    };

    const updateCombo = (catid, type, event) => {
      const data = props.category.attributes?.data || {};
      data[type] = event.key;
      productCategory.value = comboProducts.value.filter((product) => product.key === data.product)[0].category;
      const oldOther = comboOther.value;
      comboOther.value = props.combos.other.filter((item) => productCategory.value === item.category);
      if (JSON.stringify(oldOther) !== JSON.stringify(comboOther.value)) {
        data['other'] = comboOther.value[0].key;
      }
      emit('update:data', {
        target: {
          id: 'cat-' + catid + '-data',
          value: data,
        },
      });
    };

    onMounted(() => {
      if (isNil(props.category.attributes?.data?.product)) {
        emit('update:data', {
          target: {
            id: 'cat-' + props.category.id + '-data',
            value: {
              product: comboProducts.value[0].key,
              other: comboOther.value[0].key,
            },
          },
        });
      }
    });

    return {
      comboProducts,
      comboOther,
      getComboLabel,
      getComboValue,
      updateCombo,
      mltchckd,
    };
  },
};
</script>

<style lang="scss" scoped></style>
